export const addVoice = (voice) =>{
    return dispatch => {
        dispatch({ type: 'ADD_VOICE', voice});
    }
}